// extracted by mini-css-extract-plugin
module.exports = {"condition-input-row":"Sections_condition-input-row__G-Nct","value-input":"Sections_value-input__17eTC","longer":"Sections_longer__TbLiV"};